import React from 'react'
import NavBar from '../../components/NavBar/NavBar'
import Footer from '../../components/Footer/Footer'
import useStorePriority from '../../hooks/useStorePriority';
import { STORE_IMAGES } from '../../constants/urls';
import * as S from "./Styled";
import { alfabeto } from '../../constants/Lojas/alfabeto';
import useStoreList from '../../hooks/useStoreList';
import { useLocation } from 'react-router-dom';

const Lojas = () => {
  const { priorityStores, loadingPriorityStores, errorPriorityStores } = useStorePriority();
  const { listStores, loadingListStores, setErrorListStores } = useStoreList();
  const location = useLocation();

  const gridStores = priorityStores.map((store) => {
    const urlImageStore = `${STORE_IMAGES}${store.slug}.png`

    return (
      <S.StoreImageBox 
        as="a"
        key={store.id} 
        // href={`https://www.meucupom.com/cupom-desconto-${store.slug}`}
        // target="_blank"
        onClick={(e) => {
          e.preventDefault();
          const urlSlug = `cupom-desconto-${store.slug}`;
          window.open(`/${urlSlug}`, "_blank", "noopener,noreferrer");
        }}
      >
        <S.StoreImage
          src={urlImageStore} 
          alt={store.name} 
        />
      </S.StoreImageBox>
    )
  })

  const alphabetButtons = alfabeto.map((letra) => {

    const onClickLetter = () => {
      const section = document.getElementById(letra);
      section?.scrollIntoView({ behavior: 'smooth' });
    } 

    return (
      <S.alphabetButtons onClick={()=> onClickLetter()}>{letra}</S.alphabetButtons>
    )
  })

    const params = new URLSearchParams(location.search);
    const nameFilter = params.get('name')?.toLowerCase() || '';

    // Filtra as lojas dentro de cada grupo de letra
    const filteredStores = listStores.map((letter) => ({
      ...letter,
      stores: letter.stores.filter((store) =>
        store.name.toLowerCase().includes(nameFilter)
      ),
    }))
    // Remove grupos que ficaram sem lojas após o filtro
    .filter((letter) => letter.stores.length > 0);

  const storeList = filteredStores.map((letter)=> {

      
    return (
      <S.LetterBox id={letter.letter}>
        <S.Letter>{letter.letter}</S.Letter>
        <S.StoreListBox>
          {letter.stores.map((store) => {
            // const redirectLink = `https://www.meucupom.com/cupom-desconto-${store.slug}`
            return(
              <S.StoreLink target='_blank' 
              onClick={(e) => {
                e.preventDefault();
                const urlSlug = `cupom-desconto-${store.slug}`;
                window.open(`/${urlSlug}`, "_blank", "noopener,noreferrer");
              }}
              >{store.name}</S.StoreLink>
            ) 
          })}
        </S.StoreListBox>
        
      </S.LetterBox>
    )
  })

  return (
    <div>
      <NavBar/> 
      <S.StoreBox>
        <S.TitleBox>
          <S.Title>Lojas Em Destaque</S.Title>
        </S.TitleBox>           
        <S.StoreGrid>
          {gridStores}
        </S.StoreGrid>
        <S.TitleBox>
          <S.Title>Lista de Lojas em Ordem Alfabética</S.Title>
        </S.TitleBox>
        <S.alphabetButtonsBox>
          {alphabetButtons}
        </S.alphabetButtonsBox>
        <S.ListBox>
          {storeList}
        </S.ListBox>
      </S.StoreBox>
      <Footer/>
    </div>
  )
}

export default Lojas
